// Removed unused React import
import './Leaderboard.css';

const Leaderboard = ({ category, data, loading, onUserClick, currentPage = 1, itemsPerPage = 20, isSearchMode = false }) => {
  if (loading) {
    return (
      <div className="leaderboard-container">
        <div className="loading">Loading leaderboard...</div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="leaderboard-container">
        <div className="no-data">No data available for this category</div>
      </div>
    );
  }

  return (
    <div className="leaderboard-container">
      <h2 className="category-title">{getCategoryDisplayName(category)}</h2>
      <div className="leaderboard-list">
        {data.map((user, index) => {
          // Calculate the correct rank based on pagination
          const displayRank = isSearchMode && user.realRank !== undefined 
            ? user.realRank 
            : user.rank || ((currentPage - 1) * itemsPerPage) + index + 1;
            
          return (
            <div 
              key={user.id || index} 
              className="leaderboard-item"
              onClick={() => onUserClick(user)}
            >
              <div 
                className="rank"
                data-real-rank={user.realRank !== undefined ? user.realRank : undefined}
              >
                #{displayRank}
              </div>
              <div className="user-info">
                <div className="username">{user.username || `User_${user.id || user.telegram_id}`}</div>
                <div className="user-stats">
                  <div>
                    <span className="xp">{user.total_xp || 0} XP</span>
                    <span className="submissions">{user.submissions_count || 0} submissions</span>
                  </div>
                </div>
              </div>
              <div className="arrow">→</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const getCategoryDisplayName = (category) => {
  const categoryNames = {
    general: 'General Leaderboard',
    yourpost: 'X (Twitter) Leaderboard',
    comment: 'Comments Leaderboard',
    cmc: 'CoinMarketCap Leaderboard',
    referral: 'Referral Leaderboard'
  };
  return categoryNames[category] || 'Leaderboard';
};

export default Leaderboard;